// frontend/index.js
import { registerRootComponent } from "expo";
import App from "./App";                // your existing App.js
import ChatOverlay from "./app/ChatOverlay";
import { AuthProvider } from "./app/AuthContext";
// If you have a translation provider, uncomment/import it here:
// import { I18nProvider } from "./app/i18n/I18nProvider";

console.log("🚀 Frontend is running");

// // ① Service Worker registration  
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js')
//       .then(reg => console.log('SW registered, scope:', reg.scope))
//       .catch(err => console.error('SW registration failed:', err));
//   });
// }

// Wrap the full AITutor app in Auth (and i18n) just like App.js does:
const FullApp = () => (
  <AuthProvider>
    {/* <I18nProvider> */}
      <App />
    {/* </I18nProvider> */}
  </AuthProvider>
);

// Wrap the overlay in the *same* Auth (and i18n) so it can call useAuth/useTranslation:
const OverlayApp = () => (
  <AuthProvider>
    {/* <I18nProvider> */}
      <ChatOverlay />
    {/* </I18nProvider> */}
  </AuthProvider>
);

// If the path is “/chat-overlay” serve only the overlay, otherwise your full app:
// const RootComponent =
//   window.location.pathname === "/chat-overlay"
//     ? OverlayApp
//     : FullApp;

const RootComponent = (() => {
  // If the URL contains "#/chat-overlay" immediately after the hash, show only the overlay:
  if (window.location.hash === "#/chat-overlay") {
    return OverlayApp;
  }
  return FullApp;
})();

registerRootComponent(RootComponent);

// import { registerRootComponent } from "expo";  
// import App from "./App";  // ✅ Ensure it loads App.js instead of AITutorApp.js directly
// import ChatOverlay from "./app/ChatOverlay"; // ← your new overlay screen

// console.log("🚀 Frontend is running and loading App!");
// // if they hit /chat-overlay show ChatOverlay, otherwise boot your full App
// const RootComponent =
//   window.location.pathname === "/chat-overlay" ? ChatOverlay : App;

// registerRootComponent(RootComponent);

